<template>
  <div id="dwp-menu-button" class="dwp-menu-item" data-cy="dwp-open-menu" @click.prevent="toggle">
    Docket
    <div style="font-size: 10px; opacity:0.75" v-if="!loggedIn && !checking">&nbsp;(Login)</div>
    <template v-if="total && loggedIn">
      <small class="dwp-menu-item__amount">{{ done }}/{{ total }}</small>
      <progress
        class="dwp-menu-item__progress"
        style="width: 30px; height: 6px;"
        :value="progress"
        max="100"
      >{{progress}}%</progress>
    </template>
  </div>
</template>

<script>
import store from "@/store";
import { sync, get, call } from "vuex-pathify";
import hotkeys from "hotkeys-js";
import { UserIcon } from "vue-feather-icons";

export default {
  store,

  components: {
    UserIcon,
  },

  data() {
    return {
      pointer: null,
    };
  },

  computed: {
    open: sync("ui/open"),
    project: get("project/project"),
    loggedIn: get("user/user@loggedIn"),
    checking: get("user/user@checking"),
    total() {
      return this?.project?.counts?.total || 0;
    },
    done() {
      return this?.project?.counts?.done || 0;
    },
    progress() {
      return (this.done / this.total) * 100;
    },
  },

  mounted() {
    hotkeys("ctrl+/, command+/", (event, handler) => {
      this.open = !this.open;
    });
    if (docketData.pointer) {
      this.showPointer();
    }
  },

  methods: {
    toggle() {
      this.open = !this.open;
      if (this.pointer) {
        jQuery(".docket-pointer-top .close").click();
      }
    },
    showPointer() {
      this.pointer = jQuery(this.$el)
        .pointer({
          ...docketData.pointer.options,
          ...{
            pointerClass: "docket-pointer-top",
            position: {
              edge: "top",
              align: "top",
            },
            close: () => {
              this.$http.post(docketData.ajaxUrl, {
                data: {
                  action: "dwp-dismiss-intro-pointer",
                  nonce: docketData.nonce,
                },
              });
            },
          },
        })
        .pointer("open");
    },
  },
};
</script>

<style lang="scss">
.docket-pointer-top {
  .wp-pointer-arrow {
    left: 50%;
    transform: translateX(-50%);
  }
}

#wpadminbar {
  .dwp-menu-item {
    color: #ccc;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    padding-left: 12px;
    padding-right: 12px;
    margin-right: 8px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-left: 1px solid rgba(255, 255, 255, 0.1);

    .dwp-logged-out {
      height: 16px;
      fill: none;
    }

    &__amount {
      font-size: 10px !important;
    }
    &__progress,
    &__amount {
      margin-left: 8px;
    }

    &__progress {
      appearance: none;
      border: none;
      border-radius: 99999px;
      overflow: hidden;

      &[value]::-webkit-progress-bar {
        background: #666;
        border-radius: 9999px;
      }
      &[value]::-webkit-progress-value {
        background: #fff;
        border-radius: 9999px;
      }
    }

    @-moz-document url-prefix() {
      &__progress {
        background: #666;
        &[value]::-moz-progress-bar-value {
          background: #666;
          border-radius: 9999px;
        }
        &[value]::-moz-progress-bar {
          background: #fff;
          border-radius: 9999px;
        }
      }
    }
  }
}
.is-fullscreen-mode {
  .edit-post-header__settings {
    .dwp-menu-item {
      display: inline-flex;
    }
  }
}

.edit-post-header__settings {
  .dwp-menu-item {
    display: none;
    align-items: center;
    cursor: pointer;
    user-select: none;
    border: 1px solid #e2e4e7;
    background: transparent;
    padding-left: 15px;
    padding-right: 15px;
    text-decoration: none;
    font-size: 13px;
    margin: 0;
    margin-left: 0px;
    border: 0;
    cursor: pointer;
    -webkit-appearance: none;
    background: none;
    transition: box-shadow 0.1s linear;
    height: 36px;
    align-items: center;
    box-sizing: border-box;
    padding: 0 8px;
    padding-right: 8px;
    padding-left: 8px;
    overflow: hidden;
    border-radius: 3px;
    color: #555d66;
    margin-left: 4px;

    &__amount {
      font-size: 10px !important;
      line-height: 1;
    }
    &__progress,
    &__amount {
      margin-left: 8px;
    }

    &__progress {
      appearance: none;
      border: none;
      border-radius: 99999px;
      overflow: hidden;

      &[value]::-webkit-progress-bar {
        background: #e3e3e3;
        border-radius: 9999px;
      }
      &[value]::-webkit-progress-value {
        background: #666;
        border-radius: 9999px;
      }
    }

    @-moz-document url-prefix() {
      &__progress {
        background: #e3e3e3;
        &[value]::-moz-progress-bar-value {
          background: #e3e3e3;
          border-radius: 9999px;
        }
        &[value]::-moz-progress-bar {
          background: #666;
          border-radius: 9999px;
        }
      }
    }
  }
}
</style>